/* * * ./app/not-found.component.ts * * */
// Imports
import { Component } from '@angular/core';

// Component decorator
@Component({
    template: require('./not-found.component.html')
})
// Ticket class
export class NotFoundComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/not-found.component.ts